import { lazy } from 'react';

// import ReportSubjectRubric from '../components/Reports/ReportSubjectRubric';

import Dashboard from '../components/Dashboard/_Dashboard'
import AdminDashboard from '../components/Admin/Dashboard/_AdminDashboard'
import OtherDashboard from '../components/Admin/Dashboard/OtherDashboard/_OtherDashboard'
import ConsolidateDashboard from '../components/ConsolidateDashboard/_ConsolidateDashboard'
import StudentsDashboard from '../components/Students/StudentsDashboard'
import CRM from '../components/Admin/Dashboard/CRM/_CRM'
import CRMNav from '../components/CRM/_CRMNav'
import Leads from '../components/CRM/Leads'
import HRDashboard from '../components/HRPayroll/HRDashboard'
import NurseDashboard from '../components/Nurse/NurseDashboard'
import InventoryDashboard from '../components/Inventory/InventoryDashboard'
import LibraryDashboard from '../components/Library/LibraryDashboard'
import TransportationDashboard from '../components/Transportation/TransportationDashboard'
import ConcernDashboard from '../components/Concern/ConcernDashboard'

const ClassBlog = lazy(() => import('../components/ClassBlog/_ClassBlog'));
const Exams = lazy(() => import('../components/Exams/_Exams'));
const Activities = lazy(() => import('../components/Activities/_Activities'));
const Subjects = lazy(() => import('../components/Subjects/_Subjects'));
const Lessons = lazy(() => import('../components/Subjects/Lessons'));
const Lesson = lazy(() => import('../components/Subjects/Lesson'));

const WeeklyLessonPlans = lazy(() => import('../components/WeeklyLessonPlan/_WeeklyLessonPlans'));
const Planner = lazy(() => import('../components/WeeklyLessonPlan/Planner'));
const AssignedActivity = lazy(() => import('../components/AssignedActivity/_AssignedActivity'));
const ClassView = lazy(() => import('../components/ClassView/_ClassView'));
const Students = lazy(() => import('../components/Students/_Students'));
const StudentInformation = lazy(() => import('../components/Students/StudentInformation'));
const StudentTracker = lazy(() => import('../components/StudentTracker/_StudentTracker'));
const StudentAttainment = lazy(() => import('../components/StudentAttainment/_StudentAttainment'));
const AssessmentCoverage = lazy(() => import('../components/AssessmentCoverage/_AssessmentCoverage'));
const StudentAssessment = lazy(() => import('../components/Reports/StudentAssessment'));
const ReportExams = lazy(() => import('../components/Reports/ReportExams'));
const ReportCurriculumResult = lazy(() => import('../components/Reports/ReportCurriculumResult'));
const Appointments = lazy(() => import('../components/Appointments/_Appointments'));
const Main = lazy(() => import('../components/Admin/Dashboard/Main/_Main'));
const Admissions = lazy(() => import('../components/Admin/Dashboard/Admissions/_Admissions'));
const HR = lazy(() => import('../components/Admin/Dashboard/HR/_HR'));
const LMS = lazy(() => import('../components/LMS/_LMS'))
const SchoolSetup = lazy(() => import('../components/Admin/SchoolSetup/_SchoolSetup'))
const RegistrationPeriods = lazy(() => import('../components/Admin/SchoolSetup/RegistrationPeriods'))
const StudentAttendance = lazy(() => import('../components/Students/StudentAttendance'))
const StudentPastoralCare = lazy(() => import('../components/Students/StudentPastoralCare'))
const StudentGroups = lazy(() => import('../components/Students/StudentGroups'))
const StudentInformationAdmin = lazy(() => import('../components/Students/StudentInformationAdmin'))
const Discounts = lazy(() => import('../components/Discounts/_Discounts'))
const TermPolicies = lazy(() => import('../components/TermPolicies/_TermPolicies'))
const Services = lazy(() => import('../components/Services/_Services'))
const FeeStructure = lazy(() => import('../components/FeeStructure/_FeeStructure'))
const WeeklyClassPlan = lazy(() => import('../components/WeeklyClassPlan/_WeeklyClassPlan'))
const SubjectActions = lazy(() => import('../components/SubjectActions/_SubjectActions'))
const Calendar = lazy(() => import('../components/Calendar/_Calendar'))
const GradesAndAcademic = lazy(() => import('../components/GradesAndAcademic/_GradesAndAcademic'))
const ReportCohortExams = lazy(() => import('../components/Reports/ReportCohortExams'))
const ReportStudentIntegrity = lazy(() => import('../components/Reports/ReportStudentIntegrity'))
const StudentReports = lazy(() => import('../components/Students/StudentReports'))
const ReportClassAnalysis = lazy(() => import('../components/Reports/ReportClassAnalysis'))
const ReportSubjectAnalysis = lazy(() => import('../components/Reports/ReportSubjectAnalysis'))
const StudentPrintCards = lazy(() => import('../components/Students/StudentPrintCards'))
const TimetableManagement = lazy(() => import('../components/TimetableManagement/_TimetableManagement'))
const StudentPickDrop = lazy(() => import("../components/StudentPickDrop/_StudentPickDrop"))
const StudentRegistrationSimple = lazy(() => import('../components/Students/StudentRegistrationSimple'))
const CurriculumBuilder = lazy(() => import('../components/CurriculumBuilder/_CurriculumBuilder'))
const AbsenceTypes = lazy(() => import('../components/AbsenceTypes/_AbsenceTypes'))
const ExamGroupsTypes = lazy(() => import('../components/ExamGroupsTypes/_ExamGroupsTypes'))
const EarlyChildhood = lazy(() => import('../components/EarlyChildhood/_EarlyChildhood'))
const ClassMain = lazy(() => import('../components/ClassMain/_ClassMain'))
const ReportVatInvoices = lazy(() => import('../components/ReportVatInvoices/_ReportVatInvoices'))
const ReportAttendance = lazy(() => import('../components/ReportAttendance/_ReportAttendance'))
const ClassesAnalysisReport = lazy(() => import('../components/ClassesAnalysisReport/_ClassesAnalysisReport'))
const RegistrationsHistory = lazy(() => import('../components/RegistrationsHistory/_RegistrationsHistory'))
const RegisteredParentsReport = lazy(() => import('../components/RegisteredParentsReport/_RegisteredParentsReport'))
const RegisteredStudentsReport = lazy(() => import('../components/RegisteredStudentsReport/_RegisteredStudentsReport'))
const StudentsMasterReport = lazy(() => import('../components/StudentsMasterReport/_StudentsMasterReport'))
const StudentDemography = lazy(() => import('../components/StudentDemography/_StudentDemography'))
const HealthSetup = lazy(() => import('../components/HealthSetup/_HealthSetup'))
const CenterRoles = lazy(() => import('../components/CenterRoles/_CenterRoles'))
const TimetableDetailsGenerator = lazy(() => import('../components/TimetableManagement/TimetableDetailsGenerator'))
const StudentRegistrationAdvance = lazy(() => import('../components/Students/StudentRegistrationAdvance'))
const StudentCustomAttendance = lazy(() => import('../components/Students/StudentCustomAttendance'))
const ChatMonitor = lazy(() => import('../components/ChatMonitor/_ChatMonitor'))
const Classes = lazy(() => import('../components/Classes/_Classes'))
const Parents = lazy(() => import('../components/Students/Parents'))
const ReportExamAnalysis = lazy(() => import('../components/Reports/ReportExamAnalysis'))
const ReportCard = lazy(() => import('../components/Reports/ReportCard'))
const ReportCardGenerator = lazy(() => import('../components/ReportCardGenerator/_ReportCardGenerator'))
const TermRegistrations = lazy(() => import("../components/TermRegistrations/_TermRegistrations"))
const TuitionRegistrations = lazy(() => import("../components/TuitionRegistrations/_TuitionRegistrations"))
const StudentDocumentVerification = lazy(() => import("../components/StudentDocumentVerification/_StudentDocumentVerification"))
const BalanceByClass = lazy(() => import("../components/BalanceByClass/_BalanceByClass"))
const ParentAgeing1 = lazy(() => import("../components/ParentAgeing1/_ParentAgeing1"))
const NationalitiesByClass = lazy(() => import("../components/NationalitiesByClass/_NationalitiesByClass"))
const EmployeeLeavesReport = lazy(() => import("../components/EmployeeLeavesReport/EmployeeLeavesReport"))
const EmployeeSalaryHistory = lazy(() => import("../components/ReportCenter/EmployeeSalaryHistory"))
const EmployeeAssignedAssetsReport = lazy(() => import("../components/ReportCenter/EmployeeAssignedAssetsReport"))
const EmployeeMasterReport = lazy(() => import("../components/EmployeeMasterReport/_EmployeeMasterReport"))
const EmployeeSummaryReport = lazy(() => import("../components/EmployeeSummaryReport/_EmployeeSummaryReport"))
const EmployeeExperienceReport = lazy(() => import("../components/EmployeeExperienceReport/_EmployeeExperienceReport"))
const ProReport = lazy(() => import("../components/ProReport/_ProReport"))
const ActiveRegistrations = lazy(() => import("../components/ActiveRegistrations/_ActiveRegistrations"))
const ActiveStudents = lazy(() => import("../components/ActiveStudents/_ActiveStudents"))
const ReportEmployeeAttendance = lazy(() => import("../components/EmployeeAttendanceReport/_ReportEmployeeAttendance"))
const ReportEmployeeDemography = lazy(() => import("../components/EmployeeDemography/_ReportEmployeeDemography"))
const SubjectRubricInput = lazy(() => import('../components/_partials/Widgets/SubjectRubricInput'))
const EmployeeEvaluationReport = lazy(() => import("../components/Evaluations/EmployeeEvaluationReport/_EmployeeEvaluationReport"))
const ExamGroups = lazy(() => import('../components/ExamGroupsTypes/ExamGroups'))
const ExamTypes = lazy(() => import('../components/ExamGroupsTypes/ExamTypes'))
const TermAgegroupAssessment = lazy(() => import('../components/ExamGroupsTypes/TermAgegroupAssessment'))
const Gradeslevel = lazy(() => import('../components/ExamGroupsTypes/Gradeslevel'))
const ReportSubjectRubricRatio = lazy(() => import('../components/Reports/ReportSubjectRubricRatio'))
const ReportResultRubric = lazy(() => import('../components/Reports/ReportResultRubric'))
const Journal = lazy(() => import('../components/Journal/_Journal'))
const ProgressAnalysis = lazy(() => import('../components/ProgressAnalysis/_ProgressAnalysis'))
const MergeClasses = lazy(() => import('../components/MergeClasses/_MergeClasses'))
const AwardsWarnings = lazy(() => import('../components/AwardsWarnings/_AwardsWarnings'))

const ElectiveSubjectStudentsReport = lazy(() => import('../components/ElectiveSubjectStudentsReport/_ElectiveSubjectStudentsReport'));
const ReportTimetableEmployees = lazy(() => import('../components/ReportTimetableEmployees/_ReportTimetableEmployees'));


const UserTimeline = lazy(() => import('../components/UserTimeline/_UserTimeline'));
const ConsolidatedCommunication = lazy(() => import('../components/UserTimeline/_ConsolidatedCommunication'));
const UTObservation = lazy(() => import('../components/UTObservation/_UTObservation'));
const UTObservationsReview = lazy(() => import('../components/UTObservationsReview/_UTObservationsReview'));

const EarlyLearningGoalsTracker = lazy(() => import('../components/EarlyLearningGoalsTracker/_EarlyLearningGoalsTracker'));

const ReportMoe = lazy(() => import('../components/Reports/ReportMoe'));
// const ReportMoe_30052024 = lazy(() => import('../components/Reports/ReportMoe_30052024'));
const HRPayroll = lazy(() => import('../components/HRPayroll/_HRPayrollMenu'));

const EmailTemplates = lazy(() => import('../components/CRM/EmailTemplates'));
const Referrals = lazy(() => import('../components/CRM/Referrals'));
const VisitBy = lazy(() => import('../components/CRM/VisitBy'));
const NoEnrollment = lazy(() => import('../components/CRM/NoEnrollment'));
const AdmissionSetup = lazy(() => import('../components/CRM/AdmissionSetup'));
const AdmissionQnA = lazy(() => import('../components/CRM/AdmissionQnA'));

const AccountsSetup = lazy(() => import('../components/Accounts/_AccountsSetup'));
const VATAccounts = lazy(() => import('../components/Accounts/VATAccounts'));
const Banks = lazy(() => import('../components/Accounts/Banks'));
const ReceiptsAccounts = lazy(() => import('../components/Accounts/ReceiptsAccounts'));
const CostCenters = lazy(() => import('../components/Accounts/CostCenters'));
const ExpensesAccounts = lazy(() => import('../components/Accounts/ExpensesAccounts'));
const Suppliers = lazy(() => import('../components/Accounts/Suppliers'));
const AccountsSetupNav = lazy(() => import('../components/Accounts/_AccountsSetupNav'));

const OperationsNav = lazy(() => import('../components/Operations/_OperationsNav'));
const ChangeClass = lazy(() => import('../components/Operations/ChangeClass'));
const RegistrationsList = lazy(() => import('../components/Operations/RegistrationsList'));
const RegistrationsProformaList = lazy(() => import('../components/Operations/RegistrationsProformaList'));
const RegistrationsAdvanceList = lazy(() => import('../components/Operations/RegistrationsAdvanceList'));
const Invoices = lazy(() => import('../components/Operations/Invoices'));
const Receipts = lazy(() => import('../components/Operations/Receipts'));
const ReportSOA = lazy(() => import('../components/Operations/ReportSOA'));
const SOAReport = lazy(() => import('../components/ReportCenter/AccountingReports/SOAReport'));
const BatchRegistration = lazy(() => import('../components/Operations/BatchRegistration'));
const OperationReports = lazy(() => import('../components/Operations/OperationReports'));

const ExternalOperationsNav = lazy(() => import('../components/ExternalOperations/_ExternalOperationsNav'));
const Clients = lazy(() => import('../components/ExternalOperations/Clients'));


const MultiExpenses = lazy(() => import('../components/Finance/MultiExpenses'));
const MultiPayments = lazy(() => import('../components/Finance/MultiPayments'));
const PaymentVoucher = lazy(() => import('../components/Finance/PaymentVoucher'));
const Purchases = lazy(() => import('../components/Finance/Purchases'));
const Expenses = lazy(() => import('../components/Finance/Expenses'));
const DirectExpenses = lazy(() => import('../components/Finance/DirectExpenses'));
const FinanceMain = lazy(() => import('../components/Finance/_FinanceMain'));
const FinanceNav = lazy(() => import('../components/Finance/FinanceNav'));
const CashExpenses = lazy(() => import('../components/Finance/CashExpenses'));
const BankDeposits = lazy(() => import('../components/Finance/BankDeposits'));
const ReplaceCheque = lazy(() => import('../components/Finance/ReplaceCheque'));
const JournalVoucher = lazy(() => import('../components/Finance/JournalVoucher'));
const BankReconciliation = lazy(() => import('../components/Finance/BankReconciliation'));

const AlumniStudents = lazy(() => import('../components/Alumni/AlumniStudents'));
const AlumniCommunication = lazy(() => import('../components/Alumni/AlumniCommunication'));

const ReportInvoices = lazy(() => import('../components/ReportCenter/AccountingReports/ReportInvoices'));
const RevenueRegister = lazy(() => import('../components/ReportCenter/AccountingReports/RevenueRegister'));
const ReportParentStatement = lazy(() => import('../components/ReportCenter/AccountingReports/ReportParentStatement'));
const ReportStudentStatement = lazy(() => import('../components/ReportCenter/AccountingReports/ReportStudentStatement'));
const ReportChequesInHand = lazy(() => import('../components/ReportCenter/AccountingReports/ReportChequesInHand'));
const ReportChequesList = lazy(() => import('../components/ReportCenter/AccountingReports/ReportChequesList'));
const ReportBalanceSheet = lazy(() => import('../components/ReportCenter/FinancialReports/ReportBalanceSheet'));
const ReportTrialBalance = lazy(() => import('../components/ReportCenter/FinancialReports/ReportTrialBalance'));
const ReportIncomeStatement = lazy(() => import('../components/ReportCenter/FinancialReports/ReportIncomeStatement'));
const ReportMonthIncomeStatement = lazy(() => import('../components/ReportCenter/FinancialReports/ReportMonthIncomeStatement'));
const ReportVat = lazy(() => import('../components/ReportCenter/VatReports/ReportVat'));
const ReportVatList = lazy(() => import('../components/ReportCenter/VatReports/ReportVatList'));
const DownloadMedia = lazy(() => import('../components/DownloadMedia/_DownloadMedia'));
const Album = lazy(() => import('../components/DownloadMedia/Album'));

const ReportCenter = lazy(() => import('../components/ReportCenter/_ReportCenter'));
const HRReports = lazy(() => import('../components/ReportCenter/HRReports'));
const AdminReports = lazy(() => import('../components/ReportCenter/AdminReports'));
const StudentAdminReports = lazy(() => import('../components/Students/AdminReports'));
const AttendanceReports = lazy(() => import('../components/ReportCenter/AttendanceReports'));
const FinancialReports = lazy(() => import('../components/ReportCenter/FinancialReports'));
const AcademicReports = lazy(() => import('../components/ReportCenter/AcademicReports'));
const PayrollSetup = lazy(() => import('../components/PayrollSetup/_PayrollSetup'));
const AbsencesSetup = lazy(() => import('../components/PayrollSetup/AbsencesSetup'));
const AdditionsSetup = lazy(() => import('../components/PayrollSetup/AdditionsSetup'));
const AllowancesSetup = lazy(() => import('../components/PayrollSetup/AllowancesSetup'));
const DeductionsSetup = lazy(() => import('../components/PayrollSetup/DeductionsSetup'));
const LeavesSetup = lazy(() => import('../components/PayrollSetup/LeavesSetup'));
const PRSetup = lazy(() => import('../components/PayrollSetup/Setup'));
const Payroll = lazy(() => import('../components/Payroll/Payroll'));
const MonthlyPayroll = lazy(() => import('../components/Payroll/MonthlyPayroll'));
const VatReports = lazy(() => import('../components/ReportCenter/VatReports'));
const AccountingReports = lazy(() => import('../components/ReportCenter/AccountingReports'));
const StudentPromotion = lazy(() => import('../components/StudentPromotion/_StudentPromotion'));
const Navigation = lazy(() => import('../components/Navigation/_Navigation'));
const CenterNav = lazy(() => import('../components/Navigation/CenterNav'));
const NavTree = lazy(() => import('../components/Navigation/NavTree'));
const NavManager = lazy(() => import('../components/Navigation/NavManager'));
const Withdrawal = lazy(() => import('../components/Withdrawal/_Withdrawal'));
const WithdrawalSetup = lazy(() => import('../components/Withdrawal/WithdrawalSetup'));
const WithdrawalReasons = lazy(() => import('../components/Withdrawal/WithdrawalReasons'));
const WithdrawalView = lazy(() => import('../components/Withdrawal/WithdrawalView'));
const WithdrawalAdmin = lazy(() => import('../components/Withdrawal/WithdrawalAdmin'));
const WithdrawalManager = lazy(() => import('../components/Withdrawal/WithdrawalManager'));
const WithdrawalAccountant = lazy(() => import('../components/Withdrawal/WithdrawalAccountant'));
const WithdrawalParent = lazy(() => import('../components/Withdrawal/WithdrawalParent'));
const PayrollMain = lazy(() => import('../components/Payroll/_PayrollMain'));
const LeadsFollowUpReport = lazy(() => import('../components/ReportCenter/LeadsFollowUpReport'));
const EmployeeAbsences = lazy(() => import('../components/Payroll/EmployeeAbsences'));
const EmployeeAdditions = lazy(() => import('../components/Payroll/EmployeeAdditions'));
const EmployeeDeductions = lazy(() => import('../components/Payroll/EmployeeDeductions'));
const EmployeeAllowances = lazy(() => import('../components/Payroll/EmployeeAllowances'));
const EmployeeLeaves = lazy(() => import('../components/Payroll/EmployeeLeaves'));
const EmployeesMonthlyAttendanceReport = lazy(() => import('../components/EmployeesMonthlyAttendanceReport/_EmployeesMonthlyAttendanceReport'));
const EmployeeTimetableAvailability = lazy(() => import('../components/EmployeeTimetableAvailability/_EmployeeTimetableAvailability'));
const TimetablesGenerator = lazy(() => import('../components/TimetablesGenerator/_TimetablesGenerator'));
const TimetableMain = lazy(() => import('../components/Timetable/_TimetableMain'));
const StudentsMain = lazy(() => import('../components/Students/_StudentsMain'));
const Employees = lazy(() => import('../components/Employees/_Employees'));
const ClassAssignment = lazy(() => import('../components/ClassAssignment/_ClassAssignment'));
const UserRights = lazy(() => import('../components/HRPayroll/UserRights'));
const EmployeeParents = lazy(() => import('../components/HRPayroll/EmployeeParents'));
const Evaluation = lazy(() => import('../components/HRPayroll/Evaluation'));
const TeamAffairsHRReports = lazy(() => import('../components/HRPayroll/TeamAffairsHRReports'));
const WithdrawalMain = lazy(() => import('../components/WithdrawalMain/_WithdrawalMain'));
const AdmissionFormAttachments = lazy(() => import('../components/CRM/AdmissionFormAttachments'));
const EOYClosing = lazy(() => import('../components/EOYClosing/_EOYClosing'));
const EndOfService = lazy(() => import('../components/EndOfService/_EndOfService'));
const EmployeesSalary = lazy(() => import('../components/EmployeesSalary/_EmployeesSalary'));
const EmployeeAttendance = lazy(() => import('../components/EmployeeAttendance/_EmployeeAttendance'));
const EducoreBanners = lazy(() => import('../components/EducoreBanners/_EducoreBanners'));
const Nurse = lazy(() => import('../components/Nurse/_Nurse'));
const NurseStudents = lazy(() => import('../components/Nurse/NurseStudents'));
const IncidentReport = lazy(() => import('../components/Nurse/IncidentReport'));
const GradeBook = lazy(() => import('../components/GradeBook/_GradeBook'));
const GradeBookList = lazy(() => import('../components/GradeBook/GradeBookList'));
const GradeBookDetail = lazy(() => import('../components/GradeBook/GradeBookDetail'));
const GradeBookReport = lazy(() => import('../components/GradeBook/GradeBookReport'));
const GradeBookDetailLite = lazy(() => import('../components/GradeBook/GradeBookDetailLite'));
const GradeBookDashboard = lazy(() => import('../components/GradeBook/GradeBookDashboard'));
const MarketPlace = lazy(() => import('../components/MarketPlace/_MarketPlace'));
const MarketPlaceDashboard = lazy(() => import('../components/MarketPlace/MarketPlaceDashboard'));
const CenterPolicies = lazy(() => import('../components/CenterPolicies/_CenterPolicies'));
const Agenda = lazy(() => import('../components/Agenda/_Agenda'));
const Behaviors = lazy(() => import('../components/ExamGroupsTypes/Behaviors'));
const Attendances = lazy(() => import('../components/ExamGroupsTypes/Attendances'));
const CAS = lazy(() => import('../components/CAS/_CAS'));
const Essay = lazy(() => import('../components/Essay/_Essay'));
const FoodMenu = lazy(() => import('../components/FoodMenu/_FoodMenu'));
const FastTrack = lazy(() => import('../components/FastTrack/_FastTrack'));
const TOK = lazy(() => import('../components/TOK/_TOK'));
const TOKTopics = lazy(() => import('../components/TOK/TOKTopics'));
const TOKList = lazy(() => import('../components/TOK/TOKList'));

const ReportDetailedJv = lazy(() => import('../components/ReportCenter/AccountingReports/ReportDetailedJv'));
const ReportMultiJv = lazy(() => import('../components/ReportCenter/AccountingReports/ReportMultiJv'));
const ReportDetailedReceipts = lazy(() => import('../components/ReportCenter/AccountingReports/ReportDetailedReceipts'));
const ReportBouncedCheques = lazy(() => import('../components/ReportCenter/AccountingReports/ReportBouncedCheques'));
const ReportBouncedChequesDetails = lazy(() => import('../components/ReportCenter/AccountingReports/ReportBouncedChequesDetails'));
const ComparativeTermRubricReport = lazy(() => import('../components/Reports/ComparativeTermRubricReport'));
const ComparativeYearRubricReport = lazy(() => import('../components/Reports/ComparativeYearRubricReport'));
const ComparativeStdYearRubricReport = lazy(() => import('../components/Reports/ComparativeStdYearRubricReport'));

const EvaluationMenu = lazy(() => import('../components/Evaluations/EvaluationMenu'));
const ReportAppraisalGroup = lazy(() => import('../components/Evaluations/EmployeePerforma/ReportAppraisalGroup'));
const Evaluations = lazy(() => import('../components/Evaluations/_Evaluations'));
const EvaluationSetup = lazy(() => import('../components/Evaluations/EvaluationSetup/_EvaluationSetup'));
const EvaluationSubjectAnalysisReport = lazy(() => import('../components/Evaluations/EvaluationSubjectAnalysisReport/_EvaluationSubjectAnalysisReport'));

const InventoryNav = lazy(() => import('../components/Inventory/_InventoryNav'));
const Warehouses = lazy(() => import('../components/Inventory/Warehouses'));
const ItemsMovementReport = lazy(() => import('../components/Inventory/ItemsMovementReport'));
const ItemsReport = lazy(() => import('../components/Inventory/ItemsReport'));
const Consumptions = lazy(() => import('../components/Inventory/Consumptions'));
const StockMovement = lazy(() => import('../components/Inventory/StockMovement'));
const InventoryManagement = lazy(() => import('../components/Inventory/InventoryManagement'));

const StudentAttendanceReport = lazy(() => import('../components/StudentAttendanceReport/_StudentAttendanceReport'));
const ClassAttendanceReport = lazy(() => import('../components/ClassAttendanceReport/_ClassAttendanceReport'));
const SchoolAbsentReport = lazy(() => import('../components/SchoolAbsentReport/_SchoolAbsentReport'));
const ClassAttendanceDaySubjectReport = lazy(() => import('../components/ClassAttendanceDaySubjectReport/_ClassAttendanceDaySubjectReport'));

const LibraryNav = lazy(() => import('../components/Library/_LibraryNav'));
const Books = lazy(() => import('../components/Library/Books'));
const BookLeasing = lazy(() => import('../components/Library/BookLeasing'));
const BookRefs = lazy(() => import('../components/Library/BookRefs'));
const GeneralSetup = lazy(() => import('../components/Library/GeneralSetup'));
const LibrarySetup = lazy(() => import('../components/Library/LibrarySetup'));
const AnalysisReports = lazy(() => import('../components/AnalysisReports/_AnalysisReports'));

const TransportationNav = lazy(() => import('../components/Transportation/_TransportationNav'));
const Buses = lazy(() => import('../components/Transportation/Buses'));
const Routes = lazy(() => import('../components/Transportation/Routes'));
const BusRegistration = lazy(() => import('../components/Transportation/BusRegistration'));
const BusStudentOrder = lazy(() => import('../components/Transportation/BusStudentOrder'));
const BusListReport = lazy(() => import('../components/Transportation/BusListReport'));
const ConcernNav = lazy(() => import('../components/Concern/_ConcernNav'));
const ConcernSetup = lazy(() => import('../components/Concern/ConcernSetup'));
const LoginBanners = lazy(() => import('../components/LoginBanners/_LoginBanners'));
const InstallmentTracker = lazy(() => import('../components/InstallmentTracker/_InstallmentTracker'));

const UserNav = lazy(() => import('../components/User/_UserNav'));
const Profile = lazy(() => import('../components/User/Profile'));
const Documents = lazy(() => import('../components/User/Documents'));
const Notes = lazy(() => import('../components/User/Notes'));
const ChangePassword = lazy(() => import('../components/User/ChangePassword'));
const Salary = lazy(() => import('../components/User/Salary'));
const ExOpInvoices = lazy(() => import('../components/ExternalOperations/ExOpInvoices'));
const ExOpReceipts = lazy(() => import('../components/ExternalOperations/ExOpReceipts'));
const QuestionsBank = lazy(() => import('../components/QuestionsBank/_QuestionsBank'));

const ExpenseAmortization = lazy(() => import('../components/Finance/ExpenseAmortization'));

export const NavigationData = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    id: 'class-blog',
    name: 'Class Blog',
    path: '/class-blog',
    element: <ClassBlog />
  },
  {
    id: 'activities',
    name: 'Activities',
    path: '/activities',
    element: <Activities />
  },
  {
    id: 'subjects',
    name: 'Subjects',
    path: '/subjects',
    element: <Subjects />
  },
  {
    id: 'lessons',
    name: 'Lessons',
    path: '/subject/lessons',
    element: <Lessons />
  },
  {
    id: 'lesson',
    name: 'Lesson',
    path: '/subject/lesson/planner',
    element: <Lesson />
  },
  {
    id: 'weekly-lesson-plans',
    name: 'Weekly Lesson Plans',
    path: '/weekly-lesson-plans',
    element: <WeeklyLessonPlans />
  },
  {
    id: 'weekly-lesson-planner',
    name: 'Weekly Lesson Planner',
    path: '/weekly-lesson-plans/:acs_id/:tp_id/:tt_id/:acs_name',
    element: <Planner />
  },
  {
    id: 'user-timeline',
    name: 'Communication',
    path: '/user-timeline',
    element: <UserTimeline />
  },
  {
    id: 'consolidated-communication',
    name: 'Consolidated Communication',
    path: '/consolidated-communication',
    element: <ConsolidatedCommunication />
  },
  {
    id: 'assigned-activity',
    name: 'Assigned Activities',
    path: '/assigned-activity',
    element: <AssignedActivity />
  },
  {
    id: 'tasks-list',
    name: 'Tasks List',
    path: '/tasks-list',
    element: <ClassView />
  },
  // {
  //   id: 'projects',
  //   name: 'Projects',
  //   path: '/projects',
  //   element: <Projects />
  // },
  {
    id: 'exams',
    name: 'Exams',
    path: '/exams',
    element: <Exams examstypegrp_type="Exam" />
  },
  {
    id: 'exams',
    name: 'Homework',
    path: '/homework',
    element: <Exams examstypegrp_type="Homework" />
  },
  {
    id: 'exams',
    name: 'Assignment',
    path: '/assignment',
    element: <Exams examstypegrp_type="Assignment" />
  },
  {
    id: 'exams',
    name: 'Project',
    path: '/project',
    element: <Exams examstypegrp_type="Project" />
  },
  {
    id: 'exams',
    name: 'Other Assessment',
    path: '/other-assessment',
    element: <Exams examstypegrp_type="Other" />
  },
  {
    id: 'student-tracker',
    name: 'Student Attainment',
    path: '/student-tracker',
    element: <StudentTracker />
  },
  {
    id: 'student-attainment',
    name: 'Student Attainment',
    path: '/student-attainment',
    element: <StudentAttainment />
  },
  {
    id: 'assessment-coverage',
    name: 'Class Tracker',
    path: '/assessment-coverage',
    element: <AssessmentCoverage />
  },
  {
    id: 'student-journal',
    name: 'Journal',
    path: '/student-assessment',
    element: <StudentAssessment />
  },
  // {
  //     id: 'ey-report',
  //     name: 'Journal',
  //     path: '/ey-report',
  //     element: <EYReport />
  // },
  {
    id: 'report-exams',
    name: 'Report Exams',
    path: '/report-exams',
    element: <ReportExams />
  },
  {
    id: 'report-class-analysis',
    name: 'Report Class Analysis',
    path: '/report-class-analysis',
    element: <ReportClassAnalysis />
  },
  {
    id: 'report-subject-analysis',
    name: 'Report Subject Analysis',
    path: '/report-subject-analysis',
    element: <ReportSubjectAnalysis />
  },
  // {
  //     id: 'report-subject-rubric',
  //     name: 'Report Subject Rubric',
  //     path: '/report-subject-rubric',
  //     element: <ReportSubjectRubric />
  // },
  {
    id: 'report-exam-analysis',
    name: 'Report Exam Analysis',
    path: '/report-exam-analysis',
    element: <ReportExamAnalysis />
  },
  {
    id: 'comparative-term-rubric-report',
    name: 'Comparative Term Rubric Report',
    path: '/comparative-term-rubric-report',
    element: <ComparativeTermRubricReport />
  },
  {
    id: 'comparative-year-rubric-report',
    name: 'Comparative Year Rubric Report',
    path: '/comparative-year-rubric-report',
    element: <ComparativeYearRubricReport />
  },
  {
    id: 'comparative-std-year-rubric-report',
    name: 'Comparative Student Year Rubric Report',
    path: '/comparative-std-year-rubric-report',
    element: <ComparativeStdYearRubricReport />
  },
  {
    id: 'report-result-rubric',
    name: 'Report Result Rubric',
    path: '/report-result-rubric',
    element: <ReportResultRubric />
  },
  {
    id: 'report-moe',
    name: 'Report MOE',
    path: '/report-moe',
    element: <ReportMoe />
  },
  // {
  //   id: 'report-moe-old',
  //   name: 'Report MOE',
  //   path: '/report-moe-old',
  //   element: <ReportMoe_30052024 />
  // },
  {
    id: 'report-subject-rubric-ratio',
    name: 'Report Subject Rubric Ratio',
    path: '/report-subject-rubric-ratio',
    element: <ReportSubjectRubricRatio />
  },
  {
    id: 'subject-rubric-input',
    name: 'Subject Rubric Input',
    path: '/subject-rubric-input',
    element: <SubjectRubricInput />
  },
  {
    id: 'report-curriculum-result',
    name: 'Objective Result',
    path: '/report-curriculum-result',
    element: <ReportCurriculumResult />
  },
  {
    id: 'report-student-integrity',
    name: 'Student Integrity',
    path: '/report-student-integrity',
    element: <ReportStudentIntegrity />
  },
  {
    id: 'report-card',
    name: 'Student Card',
    path: '/report-card',
    element: <ReportCard />
  },
  {
    id: 'report-card-generator',
    name: 'Report Card Generator',
    path: '/report-card-generator',
    element: <ReportCardGenerator />
  },
  {
    id: 'report-cohort-exams',
    name: 'Cohort Exams',
    path: '/report-cohort-exams',
    element: <ReportCohortExams />
  },
  {
    id: 'curriculum-builder',
    name: 'Curriculum Builder',
    path: '/curriculum-builder',
    element: <CurriculumBuilder />
  },
  {
    id: 'appointments',
    name: 'Appointments',
    path: '/appointments',
    element: <Appointments />
  },
  {
    id: 'admin-dashboard',
    name: 'Admin Dashboard',
    path: '/admin/dashboard',
    element: <AdminDashboard />,
    children: [
      {
        id: 'admin-dashboard-main',
        name: 'Dashboard',
        path: 'main',
        element: <Main />
      },
      {
        id: 'admin-dashboard-other',
        name: 'Dashboard',
        path: 'other',
        element: <OtherDashboard />
      },
      {
        id: 'admin-dashboard-crm',
        name: 'CRM',
        path: 'crm',
        element: <CRM />
      },
      {
        id: 'admin-dashboard-admissions',
        name: 'Admissions',
        path: 'admissions',
        element: <Admissions />
      },
      {
        id: 'admin-dashboard-hr',
        name: 'HR',
        path: 'hr',
        element: <HR />
      },
    ]
  },
  {
    id: 'lms',
    name: 'LMS',
    path: '/lms',
    element: <LMS />,
  },
  {
    id: 'admin-school-setup',
    name: 'School Setup',
    path: '/admin/school-setup',
    element: <SchoolSetup />
  },
  {
    id: 'curriculum-builder',
    name: 'Curriculum Builder',
    path: '/curriculum-builder',
    element: <CurriculumBuilder />
  },
  {
    id: 'students-main',
    name: 'Students Main',
    path: '/students-main',
    element: <StudentsMain />
  },
  {
    id: 'students',
    name: 'Students',
    path: '/students',
    element: <Students />,
    children: [
      {
        id: 'student-information',
        name: 'Students',
        path: 'student-information',
        element: <StudentInformationAdmin />
      },
      {
        id: 'student-reports',
        name: 'Student Reports',
        path: 'student-reports',
        element: <StudentReports />
      },
      {
        id: 'student-registration-simple',
        name: 'Student Registration',
        path: 'student-registration-simple',
        element: <StudentRegistrationSimple />
      },
      {
        id: 'student-registration-advance',
        name: 'Student Registration Advance',
        path: 'student-registration-advance',
        element: <StudentRegistrationAdvance />
      },
      {
        id: 'students',
        name: 'Students',
        path: 'information',
        element: <StudentInformation />
      },
      {
        id: 'parents',
        name: 'Parents',
        path: 'parents',
        element: <Parents />
      },
      {
        id: 'student-attendance',
        name: 'Attendance',
        path: 'attendance',
        element: <StudentAttendance />
      },
      {
        id: 'student-custom-attendance',
        name: 'Custom Attendance',
        path: 'custom-attendance',
        element: <StudentCustomAttendance />
      },
      {
        id: 'student-pastoral-care',
        name: 'Pastoral Care',
        path: 'pastoral-care',
        element: <StudentPastoralCare />
      },
      {
        id: 'student-groups',
        name: 'Groups',
        path: 'groups',
        element: <StudentGroups />
      },
      {
        id: 'student-print-cards',
        name: 'Print Cards',
        path: 'student-print-cards',
        element: <StudentPrintCards />
      },
      {
        id: 'registrations-proforma-list',
        name: 'Registrations Proforma',
        path: 'registrations-proforma-list',
        element: <RegistrationsProformaList />
      },
    ]
  },
  {
    id: 'alumni-students',
    name: 'Alumni Students',
    path: '/alumni-students',
    element: <AlumniStudents />,
  },
  {
    id: 'fast-track',
    name: 'Fast Track',
    path: '/fast-track',
    element: <FastTrack />
  },
  // {
  //   id: 'employees',
  //   name: 'Employees',
  //   path: 'list',
  //   element: <List />,
  //   parent: {
  //     path: 'employees',
  //     element: <Employees />,
  //   }
  // },
  // {
  //   id: 'employee-print-cards',
  //   name: 'Employees',
  //   path: 'employee-print-cards',
  //   element: <EmployeePrintCards />,
  //   parent: {
  //     path: 'employees',
  //     element: <Employees />,
  //   }
  // },
  {
    id: 'discounts',
    name: 'Discounts',
    path: '/discounts',
    element: <Discounts />
  },
  {
    id: 'termpolicies',
    name: 'Term Fee Policies',
    path: '/termpolicies',
    element: <TermPolicies />
  },
  {
    id: 'services',
    name: 'Services',
    path: '/services',
    element: <Services />
  },

  {
    id: 'catfees',
    name: 'Fee Structure',
    path: '/catfees',
    element: <FeeStructure />
  },
  {
    id: 'weekly-class-plan',
    name: 'Weekly Class Plan',
    path: '/weekly-class-plan',
    element: <WeeklyClassPlan />
  },
  {
    id: 'subject-actions',
    name: 'Subject Actions',
    path: '/subject-actions',
    element: <SubjectActions />
  },
  {
    id: 'grades-academic',
    name: 'Grades & Academic',
    path: '/grades-academic',
    element: <GradesAndAcademic />
  },
  {
    id: 'employee-attendance-report',
    name: 'Employee Attendance Report',
    path: '/employee-attendance-report',
    element: <ReportEmployeeAttendance />
  },
  {
    id: 'employee-demography',
    name: 'Employee Demography',
    path: '/employee-demography',
    element: <ReportEmployeeDemography />
  },
  {
    id: 'calendar',
    name: 'Calendar',
    path: '/calendar',
    element: <Calendar />
  },
  {
    id: 'registration-periods',
    name: 'Registration Periods',
    path: '/registration-periods',
    element: <RegistrationPeriods />
  },
  {
    id: 'timetable-management',
    name: 'Timetable Management',
    path: '/timetable-management',
    element: <TimetableManagement />
  },
  {
    id: 'timetable-details-generator',
    name: 'Timetable Details Generator',
    path: '/timetable-details-generator',
    element: <TimetableDetailsGenerator />
  },
  {
    id: 'student-pick-drop',
    name: 'Student Pick Drop',
    path: '/student-pick-drop',
    element: <StudentPickDrop />
  },
  {
    id: 'absence-types',
    name: 'Absence Types',
    path: '/absence-types',
    element: <AbsenceTypes />
  },
  {
    id: 'early-childhood',
    name: 'Early Childhood',
    path: '/early-childhood',
    element: <EarlyChildhood />
  },
  {
    id: 'class-main',
    name: 'Class Main',
    path: '/class-main',
    element: <ClassMain />
  },
  {
    id: 'classes',
    name: 'Classes',
    path: '/classes',
    element: <Classes />
  },
  {
    id: 'report-vat-invoices',
    name: 'Report VAT Invoices',
    path: '/report-vat-invoices',
    element: <ReportVatInvoices />
  },
  {
    id: 'report-attendance',
    name: 'Report Attendance',
    path: '/report-attendance',
    element: <ReportAttendance />
  },
  {
    id: 'employees-monthly-attendance-report',
    name: 'Employees Monthly Attendance Report',
    path: '/employees-monthly-attendance-report',
    element: <EmployeesMonthlyAttendanceReport />
  },
  {
    id: 'chat-monitor',
    name: 'Chat Monitor',
    path: '/chat-monitor',
    element: <ChatMonitor />
  },
  {
    id: 'student-attendance-report',
    name: 'Student Attendance Report',
    path: '/student-attendance-report',
    element: <StudentAttendanceReport />
  },
  {
    id: 'class-attendance-report',
    name: 'Class Attendance Report',
    path: '/class-attendance-report',
    element: <ClassAttendanceReport />
  },
  {
    id: 'class--day-subject-report',
    name: 'Class Attendance Day Subject Report',
    path: '/class-attendance-day-subject-report',
    element: <ClassAttendanceDaySubjectReport />
  },
  {
    id: 'school-absent-report',
    name: 'School Absent Report',
    path: '/school-absent-report',
    element: <SchoolAbsentReport />
  },
  {
    id: 'report-balance-sheet',
    name: 'Balance Sheet Report',
    path: '/report-balance-sheet',
    element: <ReportBalanceSheet />
  },
  {
    id: 'report-trial-balance',
    name: 'Trial Balance',
    path: '/report-trial-balance',
    element: <ReportTrialBalance />
  },
  {
    id: 'report-income-statement',
    name: 'Income Statement',
    path: '/report-income-statement',
    element: <ReportIncomeStatement />
  },
  {
    id: 'report-month-income-statement',
    name: 'Monthly Income Statement',
    path: '/report-month-income-statement',
    element: <ReportMonthIncomeStatement />
  },
  {
    id: 'report-vat',
    name: 'VAT Report',
    path: '/report-vat',
    element: <ReportVat />
  },
  {
    id: 'report-vat-list',
    name: 'VAT List',
    path: '/report-vat-list',
    element: <ReportVatList />
  },
  {
    id: 'report-cheques-in-hand',
    name: 'Cheques In Hand',
    path: '/report-cheques-in-hand',
    element: <ReportChequesInHand />
  },
  {
    id: 'report-cheques-list',
    name: 'Cheques Report',
    path: '/report-cheques-list',
    element: <ReportChequesList />
  },
  {
    id: 'report-invoices',
    name: 'Invoices Report',
    path: '/report-invoices',
    element: <ReportInvoices />
  },
  {
    id: 'report-student-statement',
    name: 'Student Statement',
    path: '/report-student-statement',
    element: <ReportStudentStatement />
  },
  {
    id: 'report-parent-statement',
    name: 'Parent Statement',
    path: '/report-parent-statement',
    element: <ReportParentStatement />
  },
  {
    id: 'revenue-register',
    name: 'Revenue Register',
    path: '/revenue-register',
    element: <RevenueRegister />
  },
  {
    id: 'elective-subject-students-report',
    name: 'Elective Subject Students Report',
    path: '/elective-subject-students-report',
    element: <ElectiveSubjectStudentsReport />
  },
  {
    id: 'report-timetable-employees',
    name: 'Report Timetable Employees',
    path: '/report-timetable-employees',
    element: <ReportTimetableEmployees />
  },
  {
    id: 'classes-analysis-report',
    name: 'Classes Analysis Report',
    path: '/classes-analysis-report',
    element: <ClassesAnalysisReport />
  },
  {
    id: 'registrations-history',
    name: 'Registrations History',
    path: '/registrations-history',
    element: <RegistrationsHistory />
  },
  {
    id: 'registered-parents-report',
    name: 'Registered Parents Report',
    path: '/registered-parents-report',
    element: <RegisteredParentsReport />
  },
  {
    id: 'registered-students-report',
    name: 'Registered students Report',
    path: '/registered-students-report',
    element: <RegisteredStudentsReport />
  },
  {
    id: 'term-registrations',
    name: 'Term Registrations',
    path: '/term-registrations',
    element: <TermRegistrations />
  },
  {
    id: 'tuition-registrations',
    name: 'Tuition Registrations',
    path: '/tuition-registrations',
    element: <TuitionRegistrations />
  },
  {
    id: 'student-document-verification',
    name: 'Student Document Verification',
    path: '/student-document-verification',
    element: <StudentDocumentVerification />
  },
  {
    id: 'balance-by-class',
    name: 'Balance By Class',
    path: '/balance-by-class',
    element: <BalanceByClass />
  },
  {
    id: 'parent-ageing-1',
    name: 'Parent Ageing 1',
    path: '/parent-ageing-1',
    element: <ParentAgeing1 />
  },
  {
    id: 'nationalities-by-class',
    name: 'Nationalities By Class',
    path: '/nationalities-by-class',
    element: <NationalitiesByClass />
  },
  {
    id: 'employee-leaves-report',
    name: 'Employee Leaves Report',
    path: '/employee-leaves-report',
    element: <EmployeeLeavesReport />
  },
  {
    id: 'employee-salary-history',
    name: 'Employee Salary History',
    path: '/employee-salary-history',
    element: <EmployeeSalaryHistory />
  },
  {
    id: 'employee-assigned-assets-report',
    name: 'Employee Assigner Assets Report',
    path: '/employee-assigned-assets-report',
    element: <EmployeeAssignedAssetsReport />
  },
  {
    id: 'employee-master-report',
    name: 'Employee Master Report',
    path: '/employee-master-report',
    element: <EmployeeMasterReport />
  },
  {
    id: 'employee-summary-report',
    name: 'Employee Summary Report',
    path: '/employee-summary-report',
    element: <EmployeeSummaryReport />
  },
  {
    id: 'employee-experience-report',
    name: 'Employee Experience Report',
    path: '/employee-experience-report',
    element: <EmployeeExperienceReport />
  },
  {
    id: 'active-registrations',
    name: 'Active Registrations',
    path: '/active-registrations',
    element: <ActiveRegistrations />
  },
  {
    id: 'active-students',
    name: 'Active Students',
    path: '/active-students',
    element: <ActiveStudents />
  },
  {
    id: 'pro-report',
    name: 'Pro Report',
    path: '/pro-report',
    element: <ProReport />
  },
  {
    id: 'students-master-report',
    name: 'Students Master Report',
    path: '/students-master-report',
    element: <StudentsMasterReport />
  },
  {
    id: 'observation',
    name: 'Observation',
    path: '/observation',
    element: <UTObservation />
  },
  // {
  //   id: 'students-demography-report',
  //   name: 'Students Demography Report',
  //   path: '/students-demography-report',
  //   element: <StudentsDemographyReport />
  // },
  {
    id: 'health-setup',
    name: 'Health Setup',
    path: '/health-setup',
    element: <HealthSetup />
  },
  {
    id: 'center-roles',
    name: 'Roles',
    path: '/center-roles',
    element: <CenterRoles />
  },
  {
    id: 'student-demography',
    name: 'Student Demography',
    path: '/student-demography',
    element: <StudentDemography />
  },
  {
    id: 'hr-payroll',
    name: 'HR & Payroll',
    path: '/hr-payroll',
    element: <HRPayroll />
  },
  // {
  //     id: 'evaluations',
  //     name: 'Evaluations',
  //     path: '/evaluations',
  //     path: <Evaluations />,
  // },
  // {
  //     id: 'report-appraisal-group',
  //     name: 'Report Appraisal Group',
  //     path: '/report-appraisal-group',
  //     path: <ReportAppraisalGroup />,
  // },
  // {
  //   id: 'admin-dashboard',
  //   name: 'Admin Dashboard',
  //   path: '/admin-dashboard',
  //   element: <Dashboard />
  // },
  {
    id: 'journal',
    name: 'Journal',
    path: '/journal',
    element: <Journal />
  },
  {
    id: 'consolidate-dashboard',
    name: 'Consolidate Dashboard',
    path: '/consolidate-dashboard',
    element: <ConsolidateDashboard />
  },
  {
    id: 'finance-main',
    name: 'Finance Main',
    path: '/finance-main',
    element: <FinanceMain />
  },
  {
    id: 'finance',
    name: 'Finance',
    path: '/finance',
    element: <FinanceNav />,
    children: [
      {
        id: 'expenses',
        name: 'expenses',
        path: 'expenses',
        element: <Expenses />
      },
      {
        id: 'direct-expenses',
        name: 'Direct Expenses',
        path: 'direct-expenses',
        element: <DirectExpenses />
      },
      {
        id: 'payment-voucher',
        name: 'Payment Voucher',
        path: 'payment-voucher',
        element: <PaymentVoucher />
      },
      {
        id: 'multi-payments',
        name: 'Multi Payments',
        path: 'multi-payments',
        element: <MultiPayments />
      },
      {
        id: 'multi-expenses',
        name: 'Multi Expenses',
        path: 'multi-expenses',
        element: <MultiExpenses />
      },
      {
        id: 'cash-expenses',
        name: 'Cash Expenses',
        path: 'cash-expenses',
        element: <CashExpenses />
      },
      {
        id: 'purchases',
        name: 'Purchases',
        path: 'purchases',
        element: <Purchases />
      },
      {
        id: 'bank-deposits',
        name: 'Bank Transactions',
        path: 'bank-deposits',
        element: <BankDeposits />
      },
      {
        id: 'replace-cheque',
        name: 'Cheque Replacement',
        path: 'replace-cheque',
        element: <ReplaceCheque />
      },
      {
        id: 'journal-voucher',
        name: 'Journal Voucher',
        path: 'journal-voucher',
        element: <JournalVoucher />
      },
      {
        id: 'bank-reconciliation',
        name: 'Bank Reconciliation',
        path: 'bank-reconciliation',
        element: <BankReconciliation />
      },
      {
        id: 'financial-reports',
        name: 'Financial Reports',
        path: 'financial-reports',
        element: <FinancialReports />
      },
      {
        id: 'eoy-closing',
        name: 'EOY Closing',
        path: 'eoy-closing',
        element: <EOYClosing />
      },
      {
        id: 'expense-amortization',
        name: 'Expense Amortization',
        path: 'expense-amortization',
        element: <ExpenseAmortization />
      },
    ]
  },
  {
    id: 'accounts',
    name: 'Accounts',
    path: '/accounts',
    element: <AccountsSetupNav />,
    children: [
      {
        id: 'accounts-setup',
        name: 'Accounts Setup',
        path: 'accounts-setup',
        element: <AccountsSetup />
      },
      {
        id: 'vat-accounts',
        name: 'VAT Accounts',
        path: 'vat-accounts',
        element: <VATAccounts />
      },
      {
        id: 'banks',
        name: 'Banks',
        path: 'banks',
        element: <Banks />
      },
      {
        id: 'receipts-accounts',
        name: 'Receipts Accounts',
        path: 'receipts-accounts',
        element: <ReceiptsAccounts />
      },
      {
        id: 'cost-centers',
        name: 'Cost Centers',
        path: 'cost-centers',
        element: <CostCenters />
      },
      {
        id: 'expenses-accounts',
        name: 'Expenses Accounts',
        path: 'expenses-accounts',
        element: <ExpensesAccounts />
      },
      {
        id: 'suppliers',
        name: 'Suppliers',
        path: 'suppliers',
        element: <Suppliers />
      },
    ]
  },
  {
    id: 'observations-review',
    name: 'Observations Review',
    path: '/observations-review',
    element: <UTObservationsReview />
  },
  {
    id: 'progress-analysis',
    name: 'Progress Analysis',
    path: '/progress-analysis',
    element: <ProgressAnalysis />
  },
  {
    id: 'merge-classes',
    name: 'Merge Classes',
    path: '/merge-classes',
    element: <MergeClasses />
  },
  {
    id: 'awards-warnings',
    name: 'Awards/Warnings',
    path: '/awards-warnings',
    element: <AwardsWarnings />
  },
  {
    id: 'download-media',
    name: 'Download Media',
    path: '/download-media',
    element: <DownloadMedia />
  },
  {
    id: 'album',
    name: 'Album',
    path: '/album',
    element: <Album />,
  },
  {
    id: 'admin-reports',
    name: 'Admin Reports',
    path: '/admin-reports',
    element: <StudentAdminReports />,
  },
  {
    id: 'students-dashboard',
    name: 'Students Dashboard',
    path: '/students-dashboard',
    element: <StudentsDashboard />,
  },
  {
    id: 'alumni-communication',
    name: 'Alumni Communication',
    path: '/alumni-communication',
    element: <AlumniCommunication />,
  },
  {
    id: 'crm',
    name: 'CRM',
    path: '/crm',
    element: <CRMNav />,
    children: [
      {
        id: 'crm-dashboard',
        name: 'CRM Dashboard',
        path: 'dashboard',
        element: <CRM />
      },
      {
        id: 'waiting',
        name: 'Leads',
        path: 'waiting',
        element: <Leads />
      },
      {
        id: 'center-email-templates',
        name: 'Center Email Templates',
        path: 'center-email-templates',
        element: <EmailTemplates />
      },
      {
        id: 'referrals',
        name: 'Referrals',
        path: 'referrals',
        element: <Referrals />
      },
      {
        id: 'visitby',
        name: 'Communication Source',
        path: 'visitby',
        element: <VisitBy />
      },
      {
        id: 'noenrolment',
        name: 'No Enrollment Reasons',
        path: 'noenrolment',
        element: <NoEnrollment />
      },
      {
        id: 'admission-qna',
        name: 'Admission Q&A',
        path: 'admission-qna',
        element: <AdmissionQnA />
      },
      {
        id: 'admission-form-attachments',
        name: 'Admission Form Attachments',
        path: 'admission-form-attachments',
        element: <AdmissionFormAttachments />
      },
      {
        id: 'admission-setup',
        name: 'Admission Setup',
        path: 'admission-setup',
        element: <AdmissionSetup />
      },
    ]
  },
  {
    id: 'operations',
    name: 'Operations',
    path: '/operations',
    element: <OperationsNav />,
    children: [
      {
        id: 'registrations-proforma-list',
        name: 'Registrations Proforma',
        path: 'registrations-proforma-list',
        element: <RegistrationsProformaList />
      },
      {
        id: 'registrations-list',
        name: 'Registrations List',
        path: 'registrations-list',
        element: <RegistrationsList />
      },
      {
        id: 'registrations-advance-list',
        name: 'Registrations Invoice',
        path: 'registrations-advance-list',
        element: <RegistrationsAdvanceList />
      },
      {
        id: 'invoices',
        name: 'Invoices',
        path: 'invoices',
        element: <Invoices />
      },
      {
        id: 'receipts',
        name: 'Receipts',
        path: 'receipts',
        element: <Receipts />
      },
      {
        id: 'report-soa',
        name: 'Statement of Account',
        path: 'report-soa',
        element: <ReportSOA />
      },
      {
        id: 'batch-registration',
        name: 'Batch Registration',
        path: 'batch-registration',
        element: <BatchRegistration />
      },
      {
        id: 'change-class',
        name: 'Change Class',
        path: 'change-class',
        element: <ChangeClass />
      },
      {
        id: 'withdrawal-main',
        name: 'Withdrawal',
        path: 'withdrawal-main',
        element: <WithdrawalMain />
      },
      {
        id: 'operation-reports',
        name: 'Reports',
        path: 'operation-reports',
        element: <OperationReports />
      },
    ]
  },
  {
    id: 'report-center',
    name: 'Report Center',
    path: '/report-center',
    element: <ReportCenter />,
    children: [
      {
        id: 'hr-reports',
        name: 'HR Reports',
        path: 'hr-reports',
        element: <HRReports />
      },
      {
        id: 'admin-reports',
        name: 'Admin Reports',
        path: 'admin-reports',
        element: <AdminReports />
      },
      {
        id: 'attendance-reports',
        name: 'Attendance Reports',
        path: 'attendance-reports',
        element: <AttendanceReports />
      },
      {
        id: 'financial-reports',
        name: 'Financial Reports',
        path: 'financial-reports',
        element: <FinancialReports />
      },
      {
        id: 'accounting-reports',
        name: 'Accounting Reports',
        path: 'accounting-reports',
        element: <AccountingReports />
      },
      {
        id: 'vat-reports',
        name: 'Vat Reports',
        path: 'vat-reports',
        element: <VatReports />
      },
      {
        id: 'academic-reports',
        name: 'Academic Reports',
        path: 'academic-reports',
        element: <AcademicReports />
      },
    ]
  },
  {
    id: 'payroll-setup',
    name: 'Payroll Setup',
    path: '/payroll-setup',
    element: <PayrollSetup />,
    children: [
      {
        id: 'absences',
        name: 'Absences Setup',
        path: 'absences',
        element: <AbsencesSetup />
      },
      {
        id: 'additions',
        name: 'Additions Setup',
        path: 'additions',
        element: <AdditionsSetup />
      },
      {
        id: 'allowances',
        name: 'Allowances Setup',
        path: 'allowances',
        element: <AllowancesSetup />
      },
      {
        id: 'deductions',
        name: 'Deductions Setup',
        path: 'deductions',
        element: <DeductionsSetup />
      },
      {
        id: 'leaves',
        name: 'Leaves Setup',
        path: 'leaves',
        element: <LeavesSetup />
      },
      {
        id: 'setup',
        name: 'PR Setup',
        path: 'setup',
        element: <PRSetup />
      },
    ]
  },
  {
    id: 'payroll',
    name: 'Payroll',
    path: '/payroll',
    element: <Payroll />,
    children: [
      {
        id: 'monthly-payroll',
        name: 'Monthly Payroll',
        path: 'monthly-payroll',
        element: <MonthlyPayroll />
      },
      {
        id: 'employee-absences',
        name: 'Employee Absences',
        path: 'employee-absences',
        element: <EmployeeAbsences />
      },
      {
        id: 'employee-additions',
        name: 'Employee Additions',
        path: 'employee-additions',
        element: <EmployeeAdditions />
      },
      {
        id: 'employee-deductions',
        name: 'Employee Deductions',
        path: 'employee-deductions',
        element: <EmployeeDeductions />
      },
      {
        id: 'employee-allowances',
        name: 'Employee Allowances',
        path: 'employee-allowances',
        element: <EmployeeAllowances />
      },
      {
        id: 'employee-leaves',
        name: 'Employee Leaves',
        path: 'employee-leaves',
        element: <EmployeeLeaves />
      },
      {
        id: 'end-of-service',
        name: 'End of Service',
        path: 'end-of-service',
        element: <EndOfService />
      },
    ]
  },
  {
    id: 'payroll-main',
    name: 'Payroll Main',
    path: '/payroll-main',
    element: <PayrollMain />,
  },
  {
    id: 'exam-groups-types',
    name: 'Exam Groups & Types',
    path: '/exam-groups-types',
    element: <ExamGroupsTypes />,
    children: [
      {
        id: 'exam-groups-types-1',
        name: 'Groups',
        path: 'exam-groups-types-1',
        element: <ExamGroups />
      },
      {
        id: 'exam-groups-types-2',
        name: 'Types',
        path: 'exam-groups-types-2',
        element: <ExamTypes />
      },
      {
        id: 'exam-groups-types-4',
        name: 'Marks Percentage',
        path: 'exam-groups-types-4',
        element: <TermAgegroupAssessment />
      },
      {
        id: 'exam-groups-types-3',
        name: 'Marks Definition',
        path: 'exam-groups-types-3',
        element: <Gradeslevel />
      },
      {
        id: 'exam-groups-types-5',
        name: 'Behaviors',
        path: 'exam-groups-types-5',
        element: <Behaviors />
      },
      {
        id: 'exam-groups-types-6',
        name: 'Attendances',
        path: 'exam-groups-types-6',
        element: <Attendances />
      },
    ]
  },
  {
    id: 'evaluation-menu',
    name: 'Evaluation Menu',
    path: '/evaluation-menu',
    element: <EvaluationMenu />,
    children: [
      {
        id: 'evaluations',
        name: 'Evaluations',
        path: 'evaluations',
        element: <Evaluations />
      },
      {
        id: 'report-appraisal-group',
        name: 'Report Appraisal Group',
        path: 'report-appraisal-group',
        element: <ReportAppraisalGroup />
      },
      {
        id: 'employee-evaluation-report',
        name: 'Employee Evaluation Report',
        path: 'employee-evaluation-report',
        element: <EmployeeEvaluationReport />
      },
      {
        id: 'evaluation-setup',
        name: 'Evaluation Setup',
        path: 'employee-evaluation-report',
        element: <EvaluationSetup />
      },
      {
        id: 'evaluation-subject-analysis-report',
        name: 'Evaluation Subject Analysis Report',
        path: 'evaluation-subject-analysis-report',
        element: <EvaluationSubjectAnalysisReport />
      },
    ]
  },
  {
    id: 'early-learning-goals-tracker',
    name: 'Early Learning Goals Tracker',
    path: '/early-learning-goals-tracker',
    element: <EarlyLearningGoalsTracker />
  },
  {
    id: 'student-promotion',
    name: 'Student Promotion',
    path: '/student-promotion',
    element: <StudentPromotion />
  },
  {
    id: 'leads-follow-up-report',
    name: 'Leads Follow Up Report',
    path: '/leads-follow-up-report',
    element: <LeadsFollowUpReport />
  },
  {
    id: 'navigation',
    name: 'Navigation',
    path: '/navigation',
    element: <Navigation />,
    children: [
      {
        id: 'nav-tree',
        name: 'Navigation Tree',
        path: 'nav-tree',
        element: <NavTree />
      },
      {
        id: 'nav-manager',
        name: 'Navigation Manager',
        path: 'nav-manager',
        element: <NavManager />
      },
      {
        id: 'center-nav',
        name: 'Center Navigation',
        path: 'center-nav',
        element: <CenterNav />
      },
    ]
  },
  {
    id: 'withdrawal-reasons',
    name: 'Withdrawal Reasons',
    path: 'withdrawal-reasons',
    element: <WithdrawalReasons />
  },
  {
    id: 'withdrawal',
    name: 'Withdrawal',
    path: '/withdrawal',
    element: <Withdrawal />,
    children: [
      {
        id: 'withdrawal-view',
        name: 'Withdrawal View',
        path: 'withdrawal-view',
        element: <WithdrawalView />
      },
      {
        id: 'withdrawal-setup',
        name: 'Withdrawal Setup',
        path: 'withdrawal-setup',
        element: <WithdrawalSetup />
      },
      {
        id: 'withdrawal-admin',
        name: 'Withdrawal Admin',
        path: 'withdrawal-admin',
        element: <WithdrawalAdmin />
      },
      {
        id: 'withdrawal-manager',
        name: 'Withdrawal Manager',
        path: 'withdrawal-manager',
        element: <WithdrawalManager />
      },
      {
        id: 'withdrawal-accountant',
        name: 'Withdrawal Accountant',
        path: 'withdrawal-accountant',
        element: <WithdrawalAccountant />
      },
      {
        id: 'withdrawal-parent',
        name: 'Withdrawal Parent',
        path: 'withdrawal-parent',
        element: <WithdrawalParent />
      },
    ]
  },
  {
    id: 'employee-timetable-availability',
    name: 'Employee Timetable Availability',
    path: '/employee-timetable-availability',
    element: <EmployeeTimetableAvailability />
  },
  {
    id: 'timetables-generator',
    name: 'Timetables Generator',
    path: '/timetables-generator',
    element: <TimetablesGenerator />
  },
  {
    id: 'timetable-main',
    name: 'Timetable Main',
    path: '/timetable-main',
    element: <TimetableMain />
  },
  {
    id: 'hr-dashboard',
    name: 'HR Dashboard',
    path: '/hr-dashboard',
    element: <HRDashboard />
  },
  {
    id: 'employees',
    name: 'Employees',
    path: '/employees',
    element: <Employees />
  },
  {
    id: 'class-assignment',
    name: 'Class Assignment',
    path: '/class-assignment',
    element: <ClassAssignment />,
  },
  {
    id: 'user-rights',
    name: 'User Rights',
    path: '/user-rights',
    element: <UserRights />,
  },
  {
    id: 'evaluation',
    name: 'Evaluation',
    path: '/evaluation',
    element: <Evaluation />,
  },
  {
    id: 'employee-parents',
    name: 'Assign Employee to Parent',
    path: '/employee-parents',
    element: <EmployeeParents />,
  },
  {
    id: 'hr-reports',
    name: 'HR Reports',
    path: '/hr-reports',
    element: <TeamAffairsHRReports />
  },
  {
    id: 'employees-salary',
    name: 'Employees Salary',
    path: '/employees-salary',
    element: <EmployeesSalary />
  },
  {
    id: 'employee-attendance',
    name: 'Employee Attendance',
    path: '/employee-attendance',
    element: <EmployeeAttendance />
  },
  {
    id: 'educore-banners',
    name: 'Educore Banners',
    path: '/educore-banners',
    element: <EducoreBanners />
  },
  {
    id: 'soa-report',
    name: 'Statement of Account',
    path: '/soa-report',
    element: <SOAReport />
  },
  {
    id: 'report-detailed-jv',
    name: 'Detailed JV Report',
    path: '/report-detailed-jv',
    element: <ReportDetailedJv />
  },
  {
    id: 'report-multi-jv',
    name: 'Multi JV Report',
    path: '/report-multi-jv',
    element: <ReportMultiJv />
  },
  {
    id: 'report-detailed-receipts',
    name: 'Receipts Details Report',
    path: '/report-detailed-receipts',
    element: <ReportDetailedReceipts />
  },
  {
    id: 'report-bounced-cheques',
    name: 'Bounced Cheques Report',
    path: '/report-bounced-cheques',
    element: <ReportBouncedCheques />
  },
  {
    id: 'report-bounced-cheques-details',
    name: 'Bounced Cheques Details Report',
    path: '/report-bounced-cheques-details',
    element: <ReportBouncedChequesDetails />
  },
  {
    id: 'nurse',
    name: 'Nurse',
    path: '/nurse',
    element: <Nurse />,
    children: [
      {
        id: 'nurse-dashboard',
        name: 'Dashboard',
        path: 'nurse-dashboard',
        element: <NurseDashboard />
      },
      {
        id: 'nurse-students',
        name: 'Students',
        path: 'nurse-students',
        element: <NurseStudents />
      },
      {
        id: 'incident-report',
        name: 'Incident Report',
        path: 'incident-report',
        element: <IncidentReport />
      },
    ]
  },
  {
    id: 'grade-book',
    name: 'Grade Book',
    path: '/grade-book',
    element: <GradeBook />,
    children: [
      {
        id: 'grade-book-dashboard',
        name: 'Grade Books',
        path: 'grade-book-dashboard',
        element: <GradeBookDashboard />
      },
      {
        id: 'grade-book-list',
        name: 'Grade Books',
        path: 'grade-book-list',
        element: <GradeBookList />
      },
      {
        id: 'grade-book-detail',
        name: 'Grade Book Students',
        path: 'grade-book-detail',
        element: <GradeBookDetail />
      },
      {
        id: 'grade-book-report',
        name: 'Grade Book Report',
        path: 'grade-book-report',
        element: <GradeBookReport />
      },
    ]
  },
  {
    id: 'market-place',
    name: 'MarketPlace',
    path: '/market-place',
    element: <MarketPlace />,
    children: [
      {
        id: 'market-place-dashboard',
        name: 'MarketPlace Dashboard',
        path: 'market-place-dashboard',
        element: <MarketPlaceDashboard />
      },
    ]
  },
  {
    id: 'grade-book-detail-lite',
    name: 'Grade Book Detail',
    path: '/grade-book-detail-lite',
    element: <GradeBookDetailLite />
  },
  {
    id: 'tok',
    name: 'IB TOK',
    path: '/tok',
    element: <TOK />,
    children: [
      {
        id: 'tok-topics',
        name: 'TOK Topics',
        path: 'tok-topics',
        element: <TOKTopics />
      },
      {
        id: 'tok-list',
        name: 'TOK',
        path: 'tok-list',
        element: <TOKList />
      },
    ]
  },
  {
    id: 'center-policies',
    name: 'Center Policies',
    path: '/center-policies',
    element: <CenterPolicies />
  },
  {
    id: 'agenda',
    name: 'Agenda',
    path: '/agenda',
    element: <Agenda />
  },
  {
    id: 'cas',
    name: 'CAS',
    path: '/cas',
    element: <CAS />
  },
  {
    id: 'essay',
    name: 'Essay',
    path: '/essay',
    element: <Essay />
  },
  {
    id: 'food-menu',
    name: 'Food Menu',
    path: '/food-menu',
    element: <FoodMenu />,
  },
  {
    id: 'inventory',
    name: 'Inventory',
    path: '/inventory',
    element: <InventoryNav />,
    children: [
      {
        id: 'inventory-dashboard',
        name: 'Dashboard',
        path: 'dashboard',
        element: <InventoryDashboard />
      },
      {
        id: 'warehouses',
        name: 'Warehouses',
        path: 'warehouses',
        element: <Warehouses />
      },
      {
        id: 'items-movement-report',
        name: 'Items Movement Report',
        path: 'items-movement-report',
        element: <ItemsMovementReport />
      },
      {
        id: 'items-report',
        name: 'Items Report',
        path: 'items-report',
        element: <ItemsReport />
      },
      {
        id: 'consumptions',
        name: 'Consumptions',
        path: 'consumptions',
        element: <Consumptions />
      },
      {
        id: 'inventory-management',
        name: 'Inventory Management',
        path: 'inventory-management',
        element: <InventoryManagement />
      },
      {
        id: 'stock-movement',
        name: 'Stock Movement',
        path: 'stock-movement',
        element: <StockMovement />
      },
    ]
  },
  {
    id: 'library',
    name: 'Library',
    path: '/library',
    element: <LibraryNav />,
    children: [
      {
        id: 'library-dashboard',
        name: 'Dashboard',
        path: 'dashboard',
        element: <LibraryDashboard />
      },
      {
        id: 'books',
        name: 'Books',
        path: 'books',
        element: <Books />
      },
      {
        id: 'book-leasing',
        name: 'Book Leasing',
        path: 'book-leasing',
        element: <BookLeasing />
      },
      {
        id: 'book-refs',
        name: 'Book References',
        path: 'book-refs',
        element: <BookRefs />
      },
      {
        id: 'setup',
        name: 'Setup',
        path: 'setup',
        element: <LibrarySetup />
      },
      {
        id: 'general-setup',
        name: 'General Setup',
        path: 'general-setup',
        element: <GeneralSetup />
      },
    ]
  },
  {
    id: 'analysis-reports',
    name: 'Analysis Reports',
    path: '/analysis-reports',
    element: <AnalysisReports />
  },
  {
    id: 'transportation',
    name: 'Transportation',
    path: '/transportation',
    element: <TransportationNav />,
    children: [
      {
        id: 'transportation-dashboard',
        name: 'Dashboard',
        path: 'dashboard',
        element: <TransportationDashboard />
      },
      {
        id: 'buses',
        name: 'Buses',
        path: 'buses',
        element: <Buses />
      },
      {
        id: 'routes',
        name: 'Routes',
        path: 'routes',
        element: <Routes />
      },
      {
        id: 'bus-registration',
        name: 'Bus Registration',
        path: 'bus-registration',
        element: <BusRegistration />
      },
      {
        id: 'bus-student-order',
        name: 'Bus Student Order',
        path: 'bus-student-order',
        element: <BusStudentOrder />
      },
      {
        id: 'bus-list-report',
        name: 'Bus List Report',
        path: 'bus-list-report',
        element: <BusListReport />
      },
    ]
  },
  {
    id: 'concern',
    name: 'Concern',
    path: '/concern',
    element: <ConcernNav />,
    children: [
      {
        id: 'concern-dashboard',
        name: 'Dashboard',
        path: 'dashboard',
        element: <ConcernDashboard />
      },
      {
        id: 'concern-setup',
        name: 'Setup',
        path: 'setup',
        element: <ConcernSetup />
      },
    ]
  },
  {
    id: 'login-banners',
    name: 'Login Banners',
    path: '/login-banners',
    element: <LoginBanners />
  },
  {
    id: 'installment-tracker',
    name: 'Installment Tracker',
    path: '/installment-tracker',
    element: <InstallmentTracker />
  },
  {
    id: 'user',
    name: 'User',
    path: '/user',
    element: <UserNav />,
    children: [
      {
        id: 'profile',
        name: 'Profile',
        path: 'profile',
        element: <Profile />
      },
      {
        id: 'documents',
        name: 'Documents',
        path: 'documents',
        element: <Documents />
      },
      {
        id: 'notes',
        name: 'Notes',
        path: 'notes',
        element: <Notes />
      },
      {
        id: 'salary',
        name: 'Salary',
        path: 'salary',
        element: <Salary />
      },
      {
        id: 'change-password',
        name: 'Change Password',
        path: 'change-password',
        element: <ChangePassword />
      }
    ]
  },
  {
    id: 'external-operations',
    name: 'External Operations',
    path: '/external-operations',
    element: <ExternalOperationsNav />,
    children: [
      {
        id: 'clients',
        name: 'Clients',
        path: 'clients',
        element: <Clients />
      },
      {
        id: 'invoices',
        name: 'Invoices',
        path: 'invoices',
        element: <ExOpInvoices />
      },
      {
        id: 'receipts',
        name: 'Receipts',
        path: 'receipts',
        element: <ExOpReceipts />
      },
    ]
  },
  {
    id: 'questions-bank',
    name: 'Questions Bank',
    path: '/questions-bank',
    element: <QuestionsBank />
  },
]